{
    "luCvIs-U6pskMnZ2CHt66": {
        "position": {
            "x": 16,
            "y": 22,
            "z": 1
        },
        "templateKey": "jobs/sword",
        "jobKey": "sword",
        "affiliation": "bad",
        "key": "luCvIs-U6pskMnZ2CHt66"
    },
    "jLtfPNFXjBccA5hskxw61": {
        "position": {
            "x": 13,
            "y": 22,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "bad",
        "key": "jLtfPNFXjBccA5hskxw61"
    },
    "P0RjyK83wUUKN1lwmKS79": {
        "position": {
            "x": 14,
            "y": 19,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "P0RjyK83wUUKN1lwmKS79"
    },
    "mEs7e_3qqzRhU4CXLftvR": {
        "position": {
            "x": 16,
            "y": 18,
            "z": 1
        },
        "templateKey": "jobs/hammer",
        "jobKey": "hammer",
        "affiliation": "bad",
        "key": "mEs7e_3qqzRhU4CXLftvR"
    },
    "Ui7rJ75oYzmCc78GO-bYF": {
        "position": {
            "x": 15,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/spear",
        "jobKey": "spear",
        "affiliation": "bad",
        "key": "Ui7rJ75oYzmCc78GO-bYF"
    },
    "ozWkzSvtqhwp-sI_i9nPq": {
        "position": {
            "x": 13,
            "y": 4,
            "z": 1
        },
        "templateKey": "jobs/gun",
        "jobKey": "gun",
        "affiliation": "bad",
        "key": "ozWkzSvtqhwp-sI_i9nPq"
    },
    "LPrG4glmTAEllA57Atzzu": {
        "position": {
            "x": 16,
            "y": 5,
            "z": 1
        },
        "templateKey": "jobs/bow",
        "jobKey": "bow",
        "affiliation": "bad",
        "key": "LPrG4glmTAEllA57Atzzu"
    },
    "Y_nZid7YRqDsv8RROB-Lx": {
        "position": {
            "x": 14,
            "y": 6,
            "z": 1
        },
        "templateKey": "jobs/dagger",
        "jobKey": "dagger",
        "affiliation": "bad",
        "key": "Y_nZid7YRqDsv8RROB-Lx"
    },
    "qGPP_nUbvWfZXj9NhNF4H": {
        "position": {
            "x": 13,
            "y": 17,
            "z": 1
        },
        "templateKey": "jobs/dagger",
        "jobKey": "dagger",
        "affiliation": "bad",
        "key": "qGPP_nUbvWfZXj9NhNF4H"
    },
    "gsgtewxg1d_c1QVxmsT15": {
        "position": {
            "x": 16,
            "y": 12,
            "z": 1
        },
        "templateKey": "jobs/gun",
        "jobKey": "gun",
        "affiliation": "bad",
        "key": "gsgtewxg1d_c1QVxmsT15"
    },
    "hBAgDqGUOg4HB69aU85E6": {
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "templateKey": "jobs/spear",
        "jobKey": "spear",
        "affiliation": "bad",
        "key": "hBAgDqGUOg4HB69aU85E6"
    },
    "boss": {
        "position": {
            "x": 15,
            "y": 23,
            "z": 1
        },
        "templateKey": "jobs/swordcavalier",
        "jobKey": "swordcavalier",
        "affiliation": "bad",
        "key": "boss",
        "name": "The Boss",
        "maxhealth": 200,
        "properties": ["boss"]
    }
}
